import { Component, OnInit, EventEmitter,Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { IstSummaryService } from '../../services/ist/ist-summary.service';
import { httpOptions, serviceConstants } from '../../constants/service.constants';
import { IstDataShareService } from '../../services/ist/ist-datashare.service';
import { MessageBoxComponent } from '../message-box/message-box.component';
import { Subject } from 'rxjs';
import { DateObject, Document_Upload_File, SCREEN_CONTROL, SCREEN_RESPONSE, ScreenResponseModel } from '../../models/common';
import * as $ from 'jquery';
import { DatePipe } from '@angular/common';
import { CommonService } from 'src/app/services/common.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FileService } from 'src/app/services/file.service';

@Component({
  selector: 'app-attachment-classification',
  templateUrl: './attachment-classification.component.html',
  styleUrls: ['./attachment-classification.component.scss']
})
export class AttachmentClassificationComponent implements OnInit {

  @Input() public Content: any;
  documentOptionsConstant = [];
  heading: string;
  files: any[];
  uploadedFiles = [];
  uploadInput: EventEmitter<any>;
  humanizeBytes: Function;
  dragOver: boolean;
  ApplicationID: any;
  AttachmentForm: UntypedFormGroup;
  Classification: any;
  document_attach_list: Document_Upload_File[] = [];
  action: Subject<any> = new Subject();
  staticformFields: any;
  IsFormToched: boolean = false;
  isDateModified: boolean = false;
  Full_Date: DateObject;
  submittedresponse: SCREEN_RESPONSE[] = [];
  Status: any;
  ID: any;
  Site_Visit_Date:any;
  visitUploadedFiles:any[] = [];
  SubTypeValues:any;
  tooltipValue: any;
  constructor(public modalRef: NgbActiveModal,
    private summaryService: IstSummaryService,
    private datashareService: IstDataShareService,
    private modalService: NgbModal,
    public datepipe: DatePipe,
    private commonService: CommonService,
    public fileService: FileService,
  ) {
    this.files = [];
    this.uploadInput = new EventEmitter<any>();
  }

  ngOnInit() {
    this.AttachmentForm = new UntypedFormGroup({
      Classification: new UntypedFormControl("")
    })
    this.datashareService.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });
    this.files = [];
    this.getMasterDropDown();
    this.GetScreenConfigControls(this.Content.screencode);
  }
  changeVal($event, question) {
    question.NotimesChanged = question.NotimesChanged + 1;
    question.IsTouched = true;
    if (question.NotimesChanged >= 2)
      this.IsFormToched = true;

    setTimeout(() => {
      let selectedControl = question.ControlValue;
      if (selectedControl != "" && selectedControl != undefined && selectedControl != null) {
        let controlLabel = question.SourceItems.filter((item) => {
          return selectedControl.indexOf(item.value) > -1;
        })
        let labellist = [];
        controlLabel.forEach((item) => {
          labellist.push(item.label);
        });
        this.tooltipValue = labellist.join(",");
      }
      else {
        this.tooltipValue = "";
      }

    }, 200);

  }
  getMasterDropDown() {
    this.summaryService.masterData("api/ISTFileAttachments/GetAttachClass?ModuleName=" + this.Content.content.ModuleName+"&AppID="+this.ApplicationID + "&screencode="+this.Content.screencode).subscribe(result => {
      this.documentOptionsConstant = result["MasterData1"];
      this.documentOptionsConstant = [{label:"Select",value:"", checked: true}].concat(this.documentOptionsConstant);
    });
  }

  showFiles() {
    let files = '';
    this.uploadedFiles = [];

    for (let i = 0; i < this.files.length; i++) {
      files += this.files[i].name;
      if (!(this.files.length - 1 === i)) {
        files += ',';
      }
    }
    for (let i = 0; i < this.files.length; i++) {
      let newAttachment = this.files[i].name;
      this.uploadedFiles.push(newAttachment);
    }
    return files;
  }

  

  saveAttachments(){
    if(this.validateControls()){
      let ClasificationName = "";
      let Classification1 = "";
      let IS_Dependent_Display_Clasification = false;
      let IS_Dependent_Display_Upload = false;
      let uploadDocuments = [];
      if (this.staticformFields != null && this.staticformFields?.length > 0) {
        for (var i = 0; i < this.staticformFields?.length; i++) {
          switch (this.staticformFields[i].CONTROL) {
            case 6:
              if(this.staticformFields[i].Display_Field){
              let seletedItem = "";
              for (let c = 0; c < this.staticformFields[i].SourceItems.length; c++) {
                if (this.staticformFields[i].SourceItems[c].Checked == true) {
                  if (seletedItem == "")
                    seletedItem = this.staticformFields[i].SourceItems[c].value;
                  else
                    seletedItem = seletedItem + "," + this.staticformFields[i].SourceItems[c].value;
                }
              }
              this.staticformFields[i].ANSWER = seletedItem;
              }
              break;
              case 8:
                if(this.staticformFields[i].Display_Field){
                this.staticformFields[i].UploadedDocuments = [];
                if (this.staticformFields[i].UploadFiles) {
                  for (let j = 0; j < this.staticformFields[i].UploadFiles.length; j++) {
                    if (this.staticformFields[i].UploadFiles[j].Status == "Add" || this.staticformFields[i].UploadFiles[j].Status == "Delete") {
                      this.staticformFields[i].UploadedDocuments.push(this.staticformFields[i].UploadFiles[j]);
                    }
                  }
                  this.staticformFields[i].ANSWER = null;
                  this.staticformFields[i].ControlValue = null;
                  uploadDocuments = this.staticformFields[i].UploadedDocuments;
                }
                if(this.staticformFields[i].Display_Field && 
                  (this.staticformFields[i].FIELD_CODE == "StudyReport_CF" || this.staticformFields[i].FIELD_CODE == "Amendment_CF" ||
                  this.staticformFields[i].FIELD_CODE == "Publications_CF"  || this.staticformFields[i].FIELD_CODE == "Milestone_CF" || this.staticformFields[i].FIELD_CODE == "AllRequest_CF" 
                  )){
                  IS_Dependent_Display_Upload= (this.staticformFields[i].Display_Field && this.staticformFields[i].IS_Dependent_Display);
                }
              }
                break;
            case 10:
              if(this.staticformFields[i].Display_Field){
              let SelectedValues = this.staticformFields[i].ControlValue;
              if (SelectedValues != null && SelectedValues != undefined && SelectedValues.length > 0) {
                this.staticformFields[i].ANSWER = SelectedValues.join(",");
              }
              else {
                this.staticformFields[i].ANSWER = "";
              }
              this.staticformFields[i].SUBFIELDNAME = "";
              this.staticformFields[i].ControlValue = null;
            }
              break;
            case 5:
              if(this.staticformFields[i].Display_Field){
              let controlanswer = this.staticformFields[i].ControlValue;
              if (controlanswer != null && controlanswer != "" && controlanswer != undefined) {
                let formd = this.datepipe.transform(new Date(controlanswer), 'dd-MMM-yyyy');
                this.staticformFields[i].ANSWER = formd;
              }
              else {
                this.staticformFields[i].ANSWER = controlanswer;
              }
            }
              break;
            default:
              this.staticformFields[i].ANSWER = this.staticformFields[i].ControlValue;
              if(this.staticformFields[i].Display_Field && 
                (this.staticformFields[i].FIELD_CODE == "StudyReport_AC" || this.staticformFields[i].FIELD_CODE == "Amendment_AC" ||
                this.staticformFields[i].FIELD_CODE == "Publications_AC"  || this.staticformFields[i].FIELD_CODE == "Milestone_AC" || this.staticformFields[i].FIELD_CODE == "AllRequest_AC" 
                )){
                Classification1 = this.staticformFields[i].ControlValue;
                IS_Dependent_Display_Clasification= (this.staticformFields[i].Display_Field && this.staticformFields[i].IS_Dependent_Display);
               let drpopOption= this.staticformFields[i].GROUP_VALUES_LIST.find(x=>x.value == Classification1);
               if(drpopOption)
                 ClasificationName = drpopOption.label;
              }
              break;
          }
        }

        let fileData = [];
        let sameFiles = [];
        let hasSame: boolean = false;
        let findItem;

        var uploadData = new FormData();
        uploadDocuments.forEach(x=>
          {
            uploadData.append("" + (i + 1),x.File);
          }
        )

        if(uploadDocuments.length > 0){
          this.summaryService.FilesInsert("api/ISTFileAttachments/UploadAttachmentGrid", uploadData).subscribe(summary => {
            summary.forEach((item: any) => {
              let obj = {
                "AttachmentClassificationId": Classification1,
                "AttachmentClassification": ClasificationName,
                "FileID": item.value,
                "FileName": item.label,
                "Date": this.datepipe.transform(new Date(), 'dd-MMM-yyyy'),
                "Status": "Add",
                "IS_Dependent_Display_Clasification" :IS_Dependent_Display_Clasification,
                "IS_Dependent_Display_Upload" :IS_Dependent_Display_Upload
              };
    
              findItem = fileData.find(x => x.FileName == item.label);
    
              if(this.Content.content.filesList?.length > 0){
                findItem = this.Content.content.filesList.filter(x=> x.FileName?.toLowerCase() == item.label.toLowerCase() && x.AttachmentClassification.toLowerCase() == ClasificationName.toLowerCase());
                findItem = findItem[0];
              }
    
              if (findItem == null) {
                fileData.push(obj);
              } else {
                sameFiles.push(findItem.FileName);
                hasSame = true;
              }
            });
    
            if(hasSame){
              this.commonService.ValidationBanner("File already exists with " + sameFiles.join(', ') + " Please update the unique file name");
            } 
    
            if (!hasSame) {          
              this.modalRef.close(fileData);
            }
          });
        } else{
              let obj = {
                "AttachmentClassificationId": Classification1,
                "AttachmentClassification": ClasificationName,              
                "Date": this.datepipe.transform(new Date(), 'dd-MMM-yyyy'),
                "Status": "Add",
                "IS_Dependent_Display_Clasification" :IS_Dependent_Display_Clasification,
                "IS_Dependent_Display_Upload" :IS_Dependent_Display_Upload
              }; 
              
            let hasName =  this.Content.content.filesList.filter(x=> x.AttachmentClassificationId == Classification1 
                            && x.FileName == null );
            if(hasName.length > 0){          
              hasSame = true;
            } else{
              fileData.push(obj);
            }
           
            if (!hasSame) {          
              this.modalRef.close(fileData);
            }  else{
              this.commonService.ValidationBanner("Attachment classification exists with " + obj.AttachmentClassification);
  
            }
        }  
      }
    }
  }


  onUploadOutput(output: any | any): void {
    if (output.type === 'allAddedToQueue') {
    } else if (output.type === 'addedToQueue') {
      this.files = [];
      this.files.push(output.file); // add file to array when added
    } else if (output.type === 'uploading') {
      // update current data in files array for uploading file
      const index = this.files.findIndex(file => file.id === output.file.id);
      this.files[index] = output.file;
    } else if (output.type === 'removed') {
      // remove file from array when removed
      this.files = this.files.filter((file: any) => file !== output.file);
    } else if (output.type === 'dragOver') {
      this.dragOver = true;
    } else if (output.type === 'dragOut') {
    } else if (output.type === 'drop') {
      this.dragOver = false;
    }
    //this.showFiles();

  }

  isAllowedExtensionFile(Filename)
  {
    return this.commonService.isAllowedExtension(Filename);
  }

  BindDataToDynamicControls() {
    if (this.ApplicationID != null && this.ApplicationID != undefined && this.ApplicationID != "") {
      let sr = new ScreenResponseModel();
      sr.Id = this.Content.screencode;
      sr.RowId = this.Content.content.id;
      sr.AppId = this.ApplicationID;
      this.summaryService.getISTScreenResponse(sr).subscribe(summary => {
        this.submittedresponse = summary;
        if (this.submittedresponse != null && this.submittedresponse.length > 0) {
          for (var i = 0; i < this.staticformFields?.length; i++) {
            var response = this.submittedresponse.filter(x => x.SCREEN_CONTROL_ID == this.staticformFields[i].ID);
            
            if (response != null && response.length > 0) {
              if (this.staticformFields[i].CONTROL == '6') {
                if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "") {
                  this.staticformFields[i].ControlValue = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
                  var options = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER.split(",");
                  if (this.staticformFields[i].SourceItems != null && this.staticformFields[i].SourceItems != undefined) {
                    for (let c = 0; c < this.staticformFields[i].SourceItems.length; c++) {
                      if (options.indexOf(this.staticformFields[i].SourceItems[c].value) > -1) {
                        this.staticformFields[i].SourceItems[c].Checked = true;
                      }
                      else {
                        this.staticformFields[i].SourceItems[c].Checked = false;
                      }
                    }
                  }

                }
              }
              else if (this.staticformFields[i].CONTROL == '10') {
                this.staticformFields[i].NotimesChanged = 0;
                if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "") {
                  this.staticformFields[i].ControlValue = [];

                  var options1 = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER.split(',');
                  options1.forEach((item) => {
                    this.staticformFields[i].ControlValue.push(item);
                  });
                  this.staticformFields[i].SUBFIELDNAME = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
                }
                else {
                  this.staticformFields[i].ControlValue = [];
                }
              }
              else if (this.staticformFields[i].CONTROL == '5') {
                if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "" && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined) {
                  let formd = new Date(response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER);
                  this.staticformFields[i].ControlValue = formd;

                  if (this.staticformFields[i].DATEFORMATE == 'DD-MMM-YYYY') {
                    // let formd = this.datepipe.transform(new Date(response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER), 'dd-MMM-yyyy');
                    let formd = this.commonService.getdisplayedDate(response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER);
                    this.staticformFields[i].ControlValue = formd;
                  }

                }

              }
              else {
                this.staticformFields[i].ControlValue = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
              }
              this.staticformFields[i].UploadFiles = response[0].UploadFiles;
              if (this.staticformFields[i].CONTROL == '4') {
                this.ApplyConditions({ value: this.staticformFields[i].ControlValue }, this.staticformFields[i]);
              }
            }
          
          }
        }
        

      });
    }
  }

  BindDataToStaticControls(MainObjData:any)
  {
    for (var i = 0; i < this.staticformFields?.length; i++) {
      let ControlValue=null;
      switch (this.staticformFields[i].FIELD_CODE)
      {
          case "StudyReport_AC":
            this.staticformFields[i].Display_Field=true;
              break;
          case "StudyReport_CF":
            this.staticformFields[i].Display_Field=true;
              break;
          case "Amendment_AC":
            this.staticformFields[i].Display_Field=true;
              break;
          case "Amendment_CF":
            this.staticformFields[i].Display_Field=true;
              break;
          case "Publications_AC":
            this.staticformFields[i].Display_Field=true;
              break;
          case "Publications_CF":
            this.staticformFields[i].Display_Field=true;
              break;
          case "Milestone_AC":
            this.staticformFields[i].Display_Field=true;
              break;
          case "Milestone_CF":
            this.staticformFields[i].Display_Field=true;
              break;
          case "AllRequest_AC":
            this.staticformFields[i].Display_Field=true;
              break;    
          case "AllRequest_CF":
                this.staticformFields[i].Display_Field=true;
                  break;      
      }

      if (this.staticformFields[i].CONTROL == '4') {
        this.ApplyConditions({ value: this.staticformFields[i].ControlValue }, this.staticformFields[i]);
      }
    }
  
  }

  saveTempFiles(selectedFiles: any) {
    const formData = new FormData();
    formData.append(`files`, selectedFiles);
    return this.fileService.uploadMultiFiles(formData, "");
  }

  OpenFile(item: Document_Upload_File): void {
    if (item.Status == "Edit") {
      let Url = serviceConstants.apiURL + "api/screen/downloadfile/" + item.ID;
      window.open(Url);
    }
  }

  DeleteUpload(file, ques: SCREEN_CONTROL): void {
    this.IsFormToched = true;
    let code = file.ID;
    if (file.Status == "Add") {
      ques.UploadFiles = ques.UploadFiles.filter(function (sec) {
        return sec.ID != code;
      }, code);
    }
    else {
      this.commonService.CheckIsFileIsRefereancedInReviw(code).subscribe((x) => {
        if (x["Status"] == 2 && x["Data"] == false) {
          this.commonService.ValidationBanner(x["Message"]);
        }
        else {
          file.Status = "Delete";
        }
      });
    }
  }

  singleonChange($event, question) {
    this.IsFormToched = true;
    this.UpdateParentChildDetails(question);
    this.ApplyConditions($event, question);
  }

  UpdateParentChildDetails(question: any) {
    if (question.Control_Condtions == null || question.Control_Condtions == undefined) {
      question.Control_Condtions = [];
    }
    let displayControlIDS = [];
    let hideControlIDS = [];
    let enableControlIDS = [];
    let disbledControlIDS = [];

    question.Control_Condtions.forEach((item) => {
      item.ConditionsList.forEach((otemCon) => {
        switch (otemCon.Mapped_Condtion) {
          case "1": //display
            //displayControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            if (displayControlIDS.length == 0) {
              displayControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let disCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (disCntrIds && disCntrIds.length > 0) {
                disCntrIds.forEach((id) => {
                  if (!displayControlIDS.includes(id)) {
                    displayControlIDS.push(id);
                  }
                })
              }
            }

            break;
          case "2": //enabled

            if (enableControlIDS.length == 0) {
              enableControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let enableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (enableCntrIds && enableCntrIds.length > 0) {
                enableCntrIds.forEach((id) => {
                  if (!enableControlIDS.includes(id)) {
                    enableControlIDS.push(id);
                  }
                })
              }
            }
            break;
          case "3": //hide

            if (hideControlIDS.length == 0) {
              hideControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let hideCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (hideCntrIds && hideCntrIds.length > 0) {
                hideCntrIds.forEach((id) => {
                  if (!hideControlIDS.includes(id)) {
                    hideControlIDS.push(id);
                  }
                })
              }
            }
            break;

          case "4": //disabled
            //disbledControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            if (disbledControlIDS.length == 0) {
              disbledControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let disableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (disableCntrIds && disableCntrIds.length > 0) {
                disableCntrIds.forEach((id) => {
                  if (!disbledControlIDS.includes(id)) {
                    disbledControlIDS.push(id);
                  }
                })
              }
            }
            break;
        }
      });
    })

    this.staticformFields.forEach((con) => {
      if (displayControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Display = false;
      }
      if (hideControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Display = true;
      }
      if (enableControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Enabled = false;
      }
      if (disbledControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Enabled = true;
      }
    });

  }

  ApplyConditions($event, question) {
    let value = $event.value;
    if (question.Control_Condtions == null || question.Control_Condtions == undefined) {
      question.Control_Condtions = [];
    }
    let displayControlIDS = [];
    let hideControlIDS = [];
    let enableControlIDS = [];
    let disbledControlIDS = [];


    question.Control_Condtions.forEach((item) => {
      if (item.Mapped_Control_Value == value) {
        item.ConditionsList.forEach((otemCon) => {
          switch (otemCon.Mapped_Condtion) {
            case "1": //display
              if (displayControlIDS.length == 0) {
                displayControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let disCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (disCntrIds && disCntrIds.length > 0) {
                  disCntrIds.forEach((id) => {
                    if (!displayControlIDS.includes(id)) {
                      displayControlIDS.push(id);
                    }
                  })
                }
              }

              break;
            case "2": //enabled
              if (enableControlIDS.length == 0) {
                enableControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let enableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (enableCntrIds && enableCntrIds.length > 0) {
                  enableCntrIds.forEach((id) => {
                    if (!enableControlIDS.includes(id)) {
                      enableControlIDS.push(id);
                    }
                  })
                }
              }
              break;
            case "3": //hide
              if (hideControlIDS.length == 0) {
                hideControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let hideCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (hideCntrIds && hideCntrIds.length > 0) {
                  hideCntrIds.forEach((id) => {
                    if (!hideControlIDS.includes(id)) {
                      hideControlIDS.push(id);
                    }
                  })
                }
              }

              break;

            case "4": //disabled
              if (disbledControlIDS.length == 0) {
                disbledControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let disableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (disableCntrIds && disableCntrIds.length > 0) {
                  disableCntrIds.forEach((id) => {
                    if (!disbledControlIDS.includes(id)) {
                      disbledControlIDS.push(id);
                    }
                  })
                }
              }
              break;
          }

        });
      }
    })


    //default
    if (value != "") {
      this.staticformFields.forEach((con) => {
        // con.IS_Dependent_Display = true;
        // con.IS_Dependent_Enabled = true;
        if (displayControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Display = true;
          con.ControlValue = "";
          if (con.CONTROL == "10") {
            con.ControlValue = [];
          }
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }
        if (hideControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Display = false;
          con.ControlValue = "";
          if (con.CONTROL == "10") {
            con.ControlValue = [];
          }
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }
        if (enableControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Enabled = true;
          con.ControlValue = "";
          if (con.CONTROL == "10") {
            con.ControlValue = [];
          }
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }
        if (disbledControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Enabled = false;
          con.ControlValue = "";
          if (con.CONTROL == "10") {
            con.ControlValue = [];
          }
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }
      });
    }
  }

  DateSelect(event, question) {
    this.IsFormToched = true;
    this.isDateModified = true;
    this.Full_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.isDateModified
    }
    question.dynamicDateobj = this.Full_Date;
  }

  public p8(s: boolean): string {
    var p = (Math.random().toString(16) + "000000000").substr(2, 8);
    return s ? "-" + p.substr(0, 4) + "-" + p.substr(4, 4) : p;
  }

  CreateGuid(): string {
    return this.p8(false) + this.p8(true) + this.p8(true) + this.p8(false);
  }

  uploadchange(event, ques: SCREEN_CONTROL): void {
    //let Flag = true;    
	let Isexe = false;
    let Is5oMB = false;  
    if (ques.UploadFiles == undefined || ques.UploadFiles == null)
      ques.UploadFiles = [];
    for (let i = 0; i < event.target.files.length; i++) {
      let uploadFile = new Document_Upload_File();
      var file = event.target.files[i].name;
      var ext = file.match(/\.([^\.]+)$/)[1];
      var filesize = event.target.files[i].size;

      // if (file != null && ((filesize > 52428800) || (ext == 'exe'))) {
      //   Flag = false;
      //   //this.commonService.ValidationBanner("Please upload files with Word, PPT, Excel, Pdf, Text formats only with maximum size of 15MB");
      // }
      if (file != null && (ext == 'exe')) {
        Isexe = true;
        //this.commonService.ValidationBanner("Please upload files with Word, PPT, Excel, Pdf, Text formats only with maximum size of 50MB");
      }
      else if (file != null && ((filesize > 52428800))) {
        Is5oMB = true;
      }
      else {
        //this.saveTempFiles(event.target.files[i]).subscribe((result: any) => {
          let uploadFile = new Document_Upload_File();
          uploadFile.ID = this.CreateGuid() ;
          uploadFile.DOCUMENT_NAME = event.target.files[i].name;
          uploadFile.File = event.target.files[i];
          uploadFile.Status = "Add";
          uploadFile.UploadedDate = this.datepipe.transform(new Date().toUTCString(), 'dd-MMM-YYYY');
          let hasValue = ques.UploadFiles.filter(x => x.DOCUMENT_NAME.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase() && x.Status != "Delete");
          if (hasValue.length > 0) {
            this.commonService.ValidationBanner("File already exists with " + uploadFile.DOCUMENT_NAME + " Please update the unique file name");
          }
          else if (ques.ISALLOWMULTIPLEFILES) {
            ques.UploadFiles.push(uploadFile);
          } else {
            //ques.UploadFiles = [];
            ques.UploadFiles.forEach((item) => {
              item.Status = "Delete";
            })
            ques.UploadFiles.push(uploadFile);

          }
        //});

      }
    }
    // if (!Flag)
    //   this.commonService.ValidationBanner("Please upload files with Word, PPT, Excel, Pdf, Text formats only with maximum size of 50MB");
    if (Is5oMB && Isexe) {
      this.commonService.ValidationBanner("The system does not support .exe files. Please choose a different file format to save the details and Accepts maximum file size 50MB");
    }

    else if (Is5oMB) {
      this.commonService.ValidationBanner("Accepts maximum file size 50MB");
    }

    else if (Isexe) {
      this.commonService.ValidationBanner("The system does not support .exe files. Please choose a different file format to save the details")
    }
    else {

    }
  }

  ViewFile(fileID, fileName) {
    this.commonService.previewFile(fileID, fileName, "med");
  }

  GetScreenConfigControls(screenCode: string) {
    this.commonService.GetScreenConfigControls(screenCode, this.ApplicationID, this.Content.content.id, (ScreenData) => {
      this.staticformFields = ScreenData["SCREEN_CONTROL"];
      this.staticformFields.forEach((item) => {
        item.Display_Field = false;
      })
      this.BindDataToDynamicControls();
      this.BindDataToStaticControls(ScreenData);
    });
  }

  validateControls(): boolean {
    let isValid = true;
    let message = "";
    this.staticformFields.forEach((item) => {
      if (item.IS_MANDATORY && item.IS_Dependent_Enabled == true && item.IS_Dependent_Display == true) {
        switch (item.CONTROL) {
          case 1:
            if (!item.ControlValue && item.Display_Field) {
              $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
              $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
              message += `Please enter ${item.LABEL} <br/>`;
              isValid = false;
            }
            break;
          case 2:
          case 3: 
          if (!item.ControlValue && item.Display_Field) {
            $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
            $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
            message += `Please enter ${item.LABEL} <br/>`;
            isValid = false;
          }
            break;
          case 5:
          case 4:
            if (!item.ControlValue && item.Display_Field) {
              $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
              $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
              message += `Please select ${item.LABEL} <br/>`;
              isValid = false;
            }
            break;
          case 11:
          case 10:
            if (!item.ControlValue && item.Display_Field) {
              $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
              $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
              message += `Please enter ${item.LABEL} <br/>`;
              isValid = false;
            }
            break;
            case 6:
              let seletedItem = "";
              for (let c = 0; c < item.SourceItems.length; c++) {
                if (item.SourceItems[c].Checked == true) {
                  if (seletedItem == "")
                    seletedItem = item.SourceItems[c].value;
                  else
                    seletedItem = seletedItem + "," + item.SourceItems[c].value;
                }
              }
              item.ControlValue = seletedItem;
              if(!item.ControlValue && item.Display_Field)
              {
                $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
                $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
                message += `Please enter ${item.LABEL} <br/>`;
                isValid = false;
              }
            break;
          case 7:
            if (!item.ControlValue && item.Display_Field) {
              $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
              $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
              message += `Please enter ${item.LABEL} <br/>`;
              isValid = false;
            }
            break;
          case 8:
            if (item.UploadFiles != null && item.UploadFiles != undefined && item.UploadFiles.length == 0 && item.Display_Field) {
              $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
              $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
              message += `Please enter ${item.LABEL} <br/>`;
              isValid = false;
            }
            break;
          case 9:
            break;
        }
      }
    });

    //Check atleast single field value exists
    if (isValid) {
      isValid = this.commonService.checkHasSingleControlValue(this.staticformFields);
      if (!isValid) {
        message += `Please enter atleast one field. <br/>`;
      }
    }

    if (!isValid)
      this.commonService.ValidationBanner(message);
    return isValid;
  }

}
